<template>
  <b-container fluid>
    <div class="horizontal-menu">
      <b-row>
        <b-col>
          <h2>Sequences</h2>
        </b-col>
        <b-col class="float-right">
          <!-- Actions -->
        </b-col>
      </b-row>

      <b-nav>
        <b-nav-item :to="{name: 'sequences'}" active-class="tab_active">Sequences</b-nav-item>
      </b-nav>
    </div>

    <router-view :profile="profile" :user="user" v-if="(profile.sending_email && profile.sending_email.id) || (!profile.sending_email)"/>
  </b-container>
</template>

<script>
export default {
  props: ['profile', 'user']
}
</script>

<style>

</style>
